


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo } from '@/api/types'
import Attendance from '@/assets/attendance.png'
import FileManager from '@/assets/file-manager.png'
import Web from '@/assets/web.png'
import Subcategory from '@/assets/subcategory.png'

type Dictionary<T> = { [key: string]: T }

interface RouterLink {
  name?: string;
  params?: { [key: string]: string };
  path?: string;
  query?: Dictionary<string | (string | null)[]>;
}

interface FileInfoWithRouterLink extends FileInfo {
  Link?: RouterLink;
}

@Component({
  name: 'ExplorerJM'
})
export default class App extends Vue {
  @Prop() files!: FileInfoWithRouterLink[]
  @Prop() xattr!: string[]
  private fff: FileInfoWithRouterLink[] = []

  constructor () {
    super()
    this.files.map((v: FileInfoWithRouterLink) => {
      if (!v.XAttr) {
        return v
      }
      switch (v.XAttr.Icon) {
        case 'filemanager':
          v.XAttr.Icon = FileManager
          break
        case 'web':
          v.XAttr.Icon = Web
          break
        case 'subcategory':
          v.XAttr.Icon = Subcategory
          break
        case 'attendance':
          v.XAttr.Icon = Attendance
          break
      }
      return v
    })
  }
}

